module.exports = __webpack_public_path__ + "img/bannerOrange.9f14e3d6.jpg";